/* eslint-disable no-unused-vars */
import React from 'react';
import style from './static.module.scss';
import Avatar from 'components/avatar/avatar';
import { useAppSelector } from 'store/hooks';
import { selectRole, selectUser } from 'store/auth/authSlice';
import Skeleton from '@mui/material/Skeleton';
import { getRoleName } from 'utils/utils';
import { Link } from 'react-router-dom';
import Edit from 'components/edit/edit';
import cx from 'classnames';

export type ProfileMode = 'static' | 'editing';

export default function UserCardStatic({
  onChangeMode,
}: {
  onChangeMode: React.Dispatch<React.SetStateAction<ProfileMode>>;
}) {
  const user = useAppSelector(selectUser);
  const roleName = getRoleName(useAppSelector(selectRole) || 'viewer');

  const name = user ? (
    <span className={style.name}>{`${user?.name} ${user?.surname}`}</span>
  ) : (
    <Skeleton className={style.name} variant="text" width={150} height={22} />
  );

  const organization = user ? (
    <span className={style.organization}>{user?.organization}</span>
  ) : (
    <Skeleton
      className={style.organization}
      variant="text"
      width={250}
      height={22}
    />
  );

  const date = user ? (
    <span className={style.infoValue}>
      {new Date((user?.register_date || 0) * 1000).toLocaleDateString('fr-CH')}
    </span>
  ) : (
    <Skeleton
      className={style.infoValue}
      variant="text"
      width={150}
      height={22}
    />
  );

  const email = user ? (
    <span className={style.infoValue}>{user?.email}</span>
  ) : (
    <Skeleton
      className={style.infoValue}
      variant="text"
      width={150}
      height={22}
    />
  );

  const role = user ? (
    <span className={style.infoValue}>{roleName} </span>
  ) : (
    <Skeleton
      className={style.infoValue}
      variant="text"
      width={150}
      height={22}
    />
  );

  return (
    <div className={style.container}>
      <div className={cx(style.card, 'adaptive-userCardStatic__card')}>
        <div className={style['avatar-container']}>
          <Avatar className={style.avatar}></Avatar>
          {name}
          {organization}
        </div>
        <Edit onClick={() => onChangeMode('editing')}></Edit>
        <div className={cx(style.line, 'adaptive-userCardStatic__line')}></div>

        <div className={style.info}>
          <div className={style.infoLine}>
            <span className={style.infoName}>Дата регистрации</span>
            {date}
          </div>
          <div className={style.infoLine}>
            <span className={style.infoName}>E-mail</span>
            {email}
          </div>
          <div className={style.infoLine}>
            <span className={style.infoName}>Роль</span>
            {role}
          </div>
        </div>
      </div>
      <Link
        className={cx(style.changePassword, 'clickable-text')}
        to={'/password'}
      >
        Сменить пароль
      </Link>
    </div>
  );
}
